// @flow

// Libs
import _isEmpty from 'lodash/isEmpty'
import React, { Component } from 'react'
import 'leaflet'
import 'leaflet-path-drag'

// Components
import Grid from './Grid'

type Props = {
  selectedField: Object,
  operation: Object,
  onChangeGridOffset: Function,
  operations: Array<Object>,
  gridData: Object,
  selectedFeatureIndices: Array<number>,
}
class HeftyGrid extends Component {
  props: Props
  render (): React.Element<any> {
    const {
      selectedField,
      operation,
      onChangeGridOffset,
      operations,
      gridData,
      selectedFeatureIndices,
    } = this.props
    return (
      <div data-test='hefty-grids'>
        {selectedField && !_isEmpty(operations) && gridData
          ? (
            <Grid
              field={selectedField}
              operation={operation}
              onChangeGridOffset={onChangeGridOffset}
              gridData={gridData}
              selectedFeatureIndices={selectedFeatureIndices}
            />
          ) : null}
      </div>
    )
  }
}

export default HeftyGrid
